import GroupChatContainer from "../../../components/applications/chats/group";

const GroupChat = () => {
  return <GroupChatContainer />;
};

export default GroupChat;
